import React from 'react'

import Delivery from './Delivery'
import FileBrowsing from './FileBrowsing'
import ImportExcel from './ImportExcel'
import MasterBill from './MasterBill'
import PrintPreview from './PrintPreview'
import {
  TabLabelKey,
  useCustomsActions,
  useCustomsState
} from './stores/useCustomsStore'

import Tabs from '@/components/common/Tabs'

const CustomsDataManagement: React.FC = () => {
  const { tabLabels, activeTab } = useCustomsState()
  const { changeTabLabel } = useCustomsActions()

  return (
    <div className="h-full">
      {/* <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 h-full flex flex-col"> */}
      {/* 标签导航 */}
      {tabLabels.length > 0 && (
        <div className="flex-shrink-0">
          <Tabs
            options={tabLabels}
            activeValue={activeTab}
            onChange={(key) => changeTabLabel(key as TabLabelKey)}
          />
        </div>
      )}

      {/* 打印预览模态框 */}
      <PrintPreview />

      <div className="flex-1 overflow-auto">
        {/* 主提单查看标签 */}
        {activeTab === 'unpacking' && <MasterBill />}

        {/* 预约搬出 */}
        {activeTab === 'waiting' && <Delivery />}

        {/* 数据导入标签 */}
        {activeTab === 'importing' && <ImportExcel />}

        {activeTab === 'fileBrowsing' && <FileBrowsing />}
      </div>
      {/* </div> */}
    </div>
  )
}

export default CustomsDataManagement
